(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CompanyTypeDetailController', CompanyTypeDetailController);

    CompanyTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CompanyType'];

    function CompanyTypeDetailController($scope, $rootScope, $stateParams, entity, CompanyType) {
        var vm = this;
        vm.companyType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:companyTypeUpdate', function(event, result) {
            vm.companyType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
